import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'enl-sabre-seat-map-lib',
  template: `
    <p>
      sabre-seat-map-lib works!
    </p>
  `,
  styles: []
})
export class SabreSeatMapLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
